import { Button, Card, CardContent, Grid, Typography } from '@mui/material'
import { useLayout } from 'context'
import * as controllers from 'controllers'
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { DamagePhoto1Dto, DamagePhoto2Dto, DamagePhoto3Dto, VehicleDamageDto } from 'dtos'
import { ArrowBack } from '@mui/icons-material'
import DamageHeroCard from './DamageHeroCard'
import Step1ScanOrSearch from './Step1ScanOrSearch'
import Step2ReportDamage from './Step2ReportDamage'
import Step3DamagePhotos from './Step3DamagePhotos'
import { enqueueSnackbar } from 'notistack'
import { DamageDto } from 'dtos/damageDto'

export default function AddDamage() {
  const { vehicleGuid } = useParams()
  const layout = useLayout()
  const navigate = useNavigate()

  const [initialValues, setInitialValues] = useState<VehicleDamageDto>(new VehicleDamageDto())
  const [damageDescription, setDamageDescription] = useState<string>('')

  const [damagePhoto1, setDamagePhoto1] = useState<DamagePhoto1Dto>(new DamagePhoto1Dto())
  const [damagePhoto2, setDamagePhoto2] = useState<DamagePhoto2Dto>(new DamagePhoto2Dto())
  const [damagePhoto3, setDamagePhoto3] = useState<DamagePhoto3Dto>(new DamagePhoto3Dto())
  const [activeStep, setActiveStep] = useState<number>(0)
  const [loading, setLoading] = useState<boolean>(false)

  const handleNext = () => {
    if (activeStep === 0) {
      setActiveStep(1)
    } else if (activeStep === 1) {
      setActiveStep(2)
    } else {
    }
  }

  const handleBack = () => {
    if (activeStep === 1) {
      setActiveStep(0)
    } else if (activeStep === 2) {
      setActiveStep(1)
    }
  }

  return (
    <Grid container spacing={1} alignItems='center'>
      <Grid item xs={12}>
        <Card>
          <CardContent>
            <Grid container justifyContent='space-between'>
              <Grid item>
                <Typography fontWeight='bold' variant='h5' sx={{ pr: 1 }}>
                  Damage
                </Typography>
              </Grid>

              <Grid item xs={12} sm='auto' container spacing={2} alignItems='center' justifyContent='flex-end'>
                <Grid item>
                  <Button
                    onClick={() => {
                      navigate('/damage')
                    }}
                    color='primary'
                    startIcon={<ArrowBack />}
                    variant='text'
                  >
                    BACK
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12}>
        <DamageHeroCard damage={initialValues} />
      </Grid>

      {activeStep === 0 && (
        <Grid item xs={12}>
          <Step1ScanOrSearch
            onBack={handleBack}
            onNext={handleNext}
            damage={initialValues}
            vehicleGuid={vehicleGuid}
            setDamageData={setInitialValues}
            loading={loading}
          />
        </Grid>
      )}

      {activeStep === 1 && (
        <Grid item xs={12}>
          <Step2ReportDamage
            onBack={handleBack}
            onNext={handleNext}
            damage={initialValues}
            vehicleGuid={vehicleGuid}
            loading={loading}
            damageDescription={damageDescription}
            setDamageDescription={setDamageDescription}
          />
        </Grid>
      )}

      {activeStep === 2 && (
        <Grid item xs={12}>
          <Step3DamagePhotos
            damage={initialValues}
            onBack={handleBack}
            onNext={() => {
              layout.setIsLayoutLoading(true)

              controllers
                .createDamage(vehicleGuid!, {
                  ...initialValues,
                  vehicleGuid: vehicleGuid!,
                  initialDamageDate: initialValues.initialDamageDate?.toString(),
                  year: initialValues.year?.toString(),
                  damageDescription: damageDescription,
                  damagePhoto1FileName: damagePhoto1.damagePhoto1FileName,
                  damagePhoto2FileName: damagePhoto2.damagePhoto2FileName,
                  damagePhoto3FileName: damagePhoto3.damagePhoto3FileName
                })
                .then(() => {
                  enqueueSnackbar('Vehicle damage created successfully!', { variant: 'success' })

                  setTimeout(() => {
                    navigate('/damage')
                  }, 1000)
                })
                .finally(() => {
                  layout.setIsLayoutLoading(false)
                })
            }}
            setDamage={setInitialValues}
          />
        </Grid>
      )}
    </Grid>
  )
}
